import { render, staticRenderFns } from "./Readonly.vue?vue&type=template&id=5bbb5247&scoped=true"
import script from "./Readonly.vue?vue&type=script&lang=js"
export * from "./Readonly.vue?vue&type=script&lang=js"
import style0 from "./Readonly.vue?vue&type=style&index=0&id=5bbb5247&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbb5247",
  null
  
)

export default component.exports